// this file is generated by update_shopify_store_data.py at 2026-01-26 20:23:20.872810
var courses = [
    {
        "course_id": "48AE0B64-D360-F011-99A0-005056A740BF",
        "course_version": 1,
        "name": "Optimizing Care for Hospitalized Individuals with Intellectual and Developmental Disabilities",
        "course_type": 32,
        "author_information": "",
        "description": "This interprofessional educational program is designed to prepare healthcare professionals to deliver equitable, person-centered, and evidence-based care to individuals with intellectual and developmental disabilities (IDD). Through a series of targeted modules, participants will explore essential topics including behavioral and mental health, communication strategies, pain assessment, sensory-friendly care, clinical deterioration, discharge planning, and the impact of bias on care delivery.\r\nTo reinforce learning and promote synthesis of knowledge, the program concludes with a comprehensive case study. This case study presents a realistic clinical scenario involving a patient with IDD and challenges learners to apply concepts from all modules. Participants will work through behavioral management, communication barriers, pain assessment, sensory needs, bias mitigation, early recognition of deterioration, and discharge planning\u2014demonstrating their ability to integrate and apply the full scope of program objectives in a coordinated, patient-centered approach.",
        "learning_objectives_html": "At the conclusion, participants should be able to:",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "FE6135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Physical Therapist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                "course_category_name": "Nurse Practitioner",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D16135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Physician Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                "course_category_name": "New Graduate Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2E429D0C-4610-EE11-997D-005056A730AF",
                "course_category_name": "Golisano",
                "is_system_course_category": null
            },
            {
                "course_category_id": "787C7F5C-979E-E511-9627-005056B1456A",
                "course_category_name": "Nursing Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2FA90344-A7BA-E811-ABE9-005056B141CC",
                "course_category_name": "zRemoved-Therapist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "AAE41897-D960-F011-99A0-005056A740BF",
                "course_category_name": "Golisano - Optimizing Care for Hospitalized Individuals with Intellectual and Developmental Disabilities - Curriculum",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Physician (MD/DO)",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": null,
            "accreditation_statement": null,
            "course_level_accreditation_statement": null,
            "credit_display_name": null,
            "credit_units": null,
            "credit_unit_display_name": null
        },
        "sub_courses": [
            {
                "course_id": "99F657CC-8214-F011-9997-005056A726F7",
                "course_version": 1,
                "name": "Recognizing Symptoms of Deterioration in Patients with Intellectual and Developmental Disabilities (IDD)",
                "course_type": 1,
                "author_information": "Dr. Beth Kiss, DNP, RN, FNP-BC",
                "description": "In this module, Recognizing Symptoms of Deterioration in Patients with IDD, we discuss symptoms associated with common conditions that can lead to mortality for this population if unrecognized.",
                "learning_objectives_html": "By the time you complete this course, you will be able to:\r\n<ul>\r\n    <li>Identify the six potentially fatal conditions </li>\r\n    <li>Recognize risk factors and complications for these conditions in people with IDD </li>\r\n    <li>Identify often overlooked symptoms and signs of deterioration associated with these conditions </li>\r\n    <li>Effectively communicate recommendations to providers and care team</li>\r\n</ul>",
                "course_outline_html": "none provided",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "FEB7B714-954B-46A4-89D6-628F916FB59B",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B92FC0B9-AF4B-F011-99A4-005056A77B46",
                        "course_category_name": "CE Unlimited_BRIDGE (No DEI Courses)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2F5C3339-BDD2-EB11-80E3-005056B142B5",
                        "course_category_name": "Advance Practice Registered Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2E429D0C-4610-EE11-997D-005056A730AF",
                        "course_category_name": "Golisano",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "552455CB-0469-E811-B6FF-005056B10E33",
                        "course_category_name": "CE Unlimited featuring Challenge Tracks",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0C0B7090-D960-F011-99A0-005056A740BF",
                        "course_category_name": "Golisano - Optimizing Care for Hospitalized Individuals with Intellectual and Developmental Disabilities - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F0D93E9B-C313-F011-999F-005056A77B46",
                        "course_category_name": "Golisano-CEUnlimited",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B756B56E-BDD2-EB11-80E3-005056B142B5",
                        "course_category_name": "LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "53A09CBA-47F5-41DE-ABBC-397BDE607DA7",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BDB7B074-BDD2-EB11-80E3-005056B142B5",
                        "course_category_name": "Registered Nurse",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "<em>The Golisano Institute for Developmental Disability Nursing is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation. Provider Number P0691</em>",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.75,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "105D45AB-8914-F011-9997-005056A726F7",
                "course_version": 1,
                "name": "Case Study: Optimizing Care for Patients with Intellectual and Developmental Disabilities (IDD)",
                "course_type": 1,
                "author_information": "Dr. Deborah Napolitano, Ph.D., BCBA-D, LBA;\r\nDr. Jane Tobias, DNP, CRNP, CPNP-BC; \r\nDr. Beth Kiss, DNP, RN, FNP-BC; and\r\nDr. Holly Brown, DNP, RN, PMHNP-BC, PMHCS",
                "description": "In this course, learners will apply the principles learned in previous modules to real-life situations, gaining valuable insights into optimizing care for patients with Intellectual and Developmental Disabilities (IDD). Participants will explore strategies for addressing healthcare challenges and implementing person-centered care approaches.",
                "learning_objectives_html": "By the time you complete this course, you will be able to:\r\n<ul>\r\n    <li>Integrate knowledge of diagnostic overshadowing into the case study focused on a patient with IDD in an acute care setting</li>\r\n    <li>Apply knowledge to effectively recognize signs and symptoms of pain in the case study focused on a patient with IDD in an acute care setting</li>\r\n    <li>Apply effective communication strategies when interacting with patients with IDD to ensure their voices are heard and respected</li>\r\n    <li>Identify best practices for providing high-quality, patient-centered care to address the physical and emotional needs using a case study example of a patient with IDD in an acute care setting</li>\r\n</ul>",
                "course_outline_html": "none provided",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "552455CB-0469-E811-B6FF-005056B10E33",
                        "course_category_name": "CE Unlimited featuring Challenge Tracks",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F0D93E9B-C313-F011-999F-005056A77B46",
                        "course_category_name": "Golisano-CEUnlimited",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B92FC0B9-AF4B-F011-99A4-005056A77B46",
                        "course_category_name": "CE Unlimited_BRIDGE (No DEI Courses)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2E429D0C-4610-EE11-997D-005056A730AF",
                        "course_category_name": "Golisano",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "53A09CBA-47F5-41DE-ABBC-397BDE607DA7",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FEB7B714-954B-46A4-89D6-628F916FB59B",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2F5C3339-BDD2-EB11-80E3-005056B142B5",
                        "course_category_name": "Advance Practice Registered Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "56E42FE4-B42A-4528-8110-D8B9AC9D602B",
                        "course_category_name": "RN-BC: Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0C0B7090-D960-F011-99A0-005056A740BF",
                        "course_category_name": "Golisano - Optimizing Care for Hospitalized Individuals with Intellectual and Developmental Disabilities - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BDB7B074-BDD2-EB11-80E3-005056B142B5",
                        "course_category_name": "Registered Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B756B56E-BDD2-EB11-80E3-005056B142B5",
                        "course_category_name": "LPN",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "<em>The Golisano Institute for Developmental Disability Nursing is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation. Provider Number P0691</em>",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "F208EBA0-8014-F011-9997-005056A726F7",
                "course_version": 1,
                "name": "Pain Assessment for Hospitalized Individuals with Intellectual and Developmental Disabilities (IDD)",
                "course_type": 1,
                "author_information": "Dr. Amy Jerum, DNP, RN, CPNP-PC, PMHS-BC, PMHNP; and \r\nDr. Jane Tobias, DNP, CRNP, CPNP-BC",
                "description": "Management of pain is critical to improving outcomes for hospitalized patients. The recognition of pain for hospitalized patients with intellectual and developmental disabilities has historically been challenging for providers. In this module, you will explore strategies for the identification and assessment of pain presenting in hospitalized patients with intellectual and developmental disabilities. You will learn how to transform assessment data into strategies for effective pain management for your patient.",
                "learning_objectives_html": "By the time you complete this course, you will be able to:\r\n<ul>\r\n    <li>Describe the challenges of pain assessment in a patient with an intellectual and developmental disability (IDD)</li>\r\n    <li>Recognize symptoms of pain in a patient with an IDD</li>\r\n    <li>Describe pain assessment tools utilized in assessing pain in a&nbsp;patient with an IDD</li>\r\n    <li>Implement effective pain assessment strategies for the hospitalized patient with IDD</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "2E429D0C-4610-EE11-997D-005056A730AF",
                        "course_category_name": "Golisano",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2F5C3339-BDD2-EB11-80E3-005056B142B5",
                        "course_category_name": "Advance Practice Registered Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FEB7B714-954B-46A4-89D6-628F916FB59B",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B756B56E-BDD2-EB11-80E3-005056B142B5",
                        "course_category_name": "LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "53A09CBA-47F5-41DE-ABBC-397BDE607DA7",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0C0B7090-D960-F011-99A0-005056A740BF",
                        "course_category_name": "Golisano - Optimizing Care for Hospitalized Individuals with Intellectual and Developmental Disabilities - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BDB7B074-BDD2-EB11-80E3-005056B142B5",
                        "course_category_name": "Registered Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F0D93E9B-C313-F011-999F-005056A77B46",
                        "course_category_name": "Golisano-CEUnlimited",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5AE0CD99-4B63-4719-B571-1B7E15ADCBA7",
                        "course_category_name": "RN-BC: Pain Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "552455CB-0469-E811-B6FF-005056B10E33",
                        "course_category_name": "CE Unlimited featuring Challenge Tracks",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B92FC0B9-AF4B-F011-99A4-005056A77B46",
                        "course_category_name": "CE Unlimited_BRIDGE (No DEI Courses)",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "<em>The Golisano Institute for Developmental Disability Nursing is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation. Provider Number P0691</em>",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.75,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "824FD93C-8614-F011-9997-005056A726F7",
                "course_version": 1,
                "name": "Designing a Patient Centered Plan for In-patient Care and Safe Discharge for Hospitalized Adults with Intellectual and Developmental Disabilities (IDD)",
                "course_type": 1,
                "author_information": "Dr. Sarah Ailey Ph.D. APHN, RN FAAN;\r\nDr. Holly Brown, DNP, RN, PMHNP-BC, PMHCS; and\r\nDr. Dianne Cooney Miner PhD, RN FAAN",
                "description": "Throughout this module, we will explore standards of care and evidence-based interventions that foster patient safety and provide for patient comfort and well-being during and after their hospitalization. This module emphasizes the importance of collaboration with the patient and their support system in the development of the plan of care for hospitalization, for discharge and for post hospital care.",
                "learning_objectives_html": "By the time you complete this course, you will be able to:\r\n<ul>\r\n    <li>Design a patient-centered plan of care for hospitalized patients with IDD to:\r\n    <ol>\r\n        <li>Achieve quality outcomes. </li>\r\n        <li>Prevent adverse events.</li>\r\n    </ol>\r\n    </li>\r\n    <li>Incorporate patient-centered nursing interventions into discharge planning with the goal of:\r\n    <ol>\r\n        <li>Achieving a safe transition from the hospital.</li>\r\n        <li>Supporting patients with IDD's continuum of care.</li>\r\n    </ol>\r\n    </li>\r\n</ul>",
                "course_outline_html": "none provided",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "B92FC0B9-AF4B-F011-99A4-005056A77B46",
                        "course_category_name": "CE Unlimited_BRIDGE (No DEI Courses)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BDB7B074-BDD2-EB11-80E3-005056B142B5",
                        "course_category_name": "Registered Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "552455CB-0469-E811-B6FF-005056B10E33",
                        "course_category_name": "CE Unlimited featuring Challenge Tracks",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F0D93E9B-C313-F011-999F-005056A77B46",
                        "course_category_name": "Golisano-CEUnlimited",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2E429D0C-4610-EE11-997D-005056A730AF",
                        "course_category_name": "Golisano",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FEB7B714-954B-46A4-89D6-628F916FB59B",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2F5C3339-BDD2-EB11-80E3-005056B142B5",
                        "course_category_name": "Advance Practice Registered Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B756B56E-BDD2-EB11-80E3-005056B142B5",
                        "course_category_name": "LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "53A09CBA-47F5-41DE-ABBC-397BDE607DA7",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0C0B7090-D960-F011-99A0-005056A740BF",
                        "course_category_name": "Golisano - Optimizing Care for Hospitalized Individuals with Intellectual and Developmental Disabilities - Courses",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "<em>The Golisano Institute for Developmental Disability Nursing is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation. Provider Number P0691</em>",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "6F66E66B-ED13-F011-999F-005056A77B46",
                "course_version": 1,
                "name": "Sensory Friendly Interventions for Patients with Intellectual and Developmental Disabilities (IDD)",
                "course_type": 1,
                "author_information": "Dr. Amy Jerum, DNP, RN, CPNP-PC, PMHS-BC, PMHNP;\r\nDr. Jane Tobias, DNP, CRNP, CPNP-BC;\r\nDr. Holly Brown, DNP, RN, PMHNP-BC, PMHCS",
                "description": "In this module we will explore sensory considerations for individuals with IDD. In particular, this course will provide guidance on strategies for integrating interventions that are sensory-focused and can be utilized in combination with behavioral supports, such as sensory-smart spaces, to reduce behaviors of concern for hospitalized patients.",
                "learning_objectives_html": "By the time you complete this course, you will be able to:\r\n<ul>\r\n    <li>Explain the different components of the sensory system and how it is affected by internal and external stimuli</li>\r\n    <li>Identify the indicators of sensory-related behaviors, highlighting the role of external factors such as the environment and personal factors such as effective communication to make needs known</li>\r\n    <li>Detail the benefits of sensory-friendly interventions and strategic ways to use them to support coping for hospitalized patients with IDD</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "F0D93E9B-C313-F011-999F-005056A77B46",
                        "course_category_name": "Golisano-CEUnlimited",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B756B56E-BDD2-EB11-80E3-005056B142B5",
                        "course_category_name": "LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FEB7B714-954B-46A4-89D6-628F916FB59B",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2E429D0C-4610-EE11-997D-005056A730AF",
                        "course_category_name": "Golisano",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B92FC0B9-AF4B-F011-99A4-005056A77B46",
                        "course_category_name": "CE Unlimited_BRIDGE (No DEI Courses)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "552455CB-0469-E811-B6FF-005056B10E33",
                        "course_category_name": "CE Unlimited featuring Challenge Tracks",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BDB7B074-BDD2-EB11-80E3-005056B142B5",
                        "course_category_name": "Registered Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0C0B7090-D960-F011-99A0-005056A740BF",
                        "course_category_name": "Golisano - Optimizing Care for Hospitalized Individuals with Intellectual and Developmental Disabilities - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "53A09CBA-47F5-41DE-ABBC-397BDE607DA7",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2F5C3339-BDD2-EB11-80E3-005056B142B5",
                        "course_category_name": "Advance Practice Registered Nurse",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "<em>The Golisano Institute for Developmental Disability Nursing is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation. Provider Number P0691</em>",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "F82B4AC9-E913-F011-999F-005056A77B46",
                "course_version": 1,
                "name": "Behavioral and Mental Health Concerns in Patients with Intellectual and Developmental Disabilities (IDD)",
                "course_type": 1,
                "author_information": "Dr. Holly Brown, DNP, RN, PMHNP-BC, PMHCS; \r\nDr. Janeice DeSocio, Ph.D., RN, PMHNP-BC, FAAN;\r\nDr. Shirley McMillan Ph.D., RN, CDDN;\r\nDr. Deborah Napolitano, Ph.D., BCBA-D, LBA",
                "description": "In this module we will explore the reasons behind some behaviors of concern you may see in the hospital setting when working with individuals with intellectual and developmental disabilities, how to assess them, and how to respond.",
                "learning_objectives_html": "By the time you complete this course, you will be able to:\r\n<ul>\r\n    <li>Analyze causes of behaviors of concern in hospitalized patients with intellectual and developmental disabilities (IDD)</li>\r\n    <li>Apply the HELP framework in assessing behaviors of concern in hospitalized patients with IDD</li>\r\n    <li>Evaluate the effectiveness of interventions to reduce behaviors of concern in hospitalized patients with IDD</li>\r\n    <li>Differentiate interprofessional team contributions for effective treatment planning for the prevention and intervention for behaviors of concern</li>\r\n    <li>Describe pharmacological strategies for managing behaviors of concern and underlying mental health concerns that may be exacerbated in the context of hospital settings</li>\r\n    <li>Appraise the impact of diagnostic overshadowing as it applies to hospitalized patients with IDD when behaviors of concern are present</li>\r\n</ul>",
                "course_outline_html": "none provided",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "2E429D0C-4610-EE11-997D-005056A730AF",
                        "course_category_name": "Golisano",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F0D93E9B-C313-F011-999F-005056A77B46",
                        "course_category_name": "Golisano-CEUnlimited",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B756B56E-BDD2-EB11-80E3-005056B142B5",
                        "course_category_name": "LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "552455CB-0469-E811-B6FF-005056B10E33",
                        "course_category_name": "CE Unlimited featuring Challenge Tracks",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2F5C3339-BDD2-EB11-80E3-005056B142B5",
                        "course_category_name": "Advance Practice Registered Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FEB7B714-954B-46A4-89D6-628F916FB59B",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B81F2B19-568D-4420-B695-B14EBFD6C36B",
                        "course_category_name": "RN-BC: Gerontological",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0C0B7090-D960-F011-99A0-005056A740BF",
                        "course_category_name": "Golisano - Optimizing Care for Hospitalized Individuals with Intellectual and Developmental Disabilities - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "53A09CBA-47F5-41DE-ABBC-397BDE607DA7",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5AC718D0-4CCE-4066-9398-56DBED0B6FC7",
                        "course_category_name": "PMH-BC: Psych/Mental Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "162D7419-F1DE-4896-A447-ED5F2D41A1C1",
                        "course_category_name": "CMSRN: Medical-Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BDB7B074-BDD2-EB11-80E3-005056B142B5",
                        "course_category_name": "Registered Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B92FC0B9-AF4B-F011-99A4-005056A77B46",
                        "course_category_name": "CE Unlimited_BRIDGE (No DEI Courses)",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "<em>The Golisano Institute for Developmental Disability Nursing is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation. Provider Number P0691</em>",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "FD68102D-6CCF-EF11-9991-005056A7DAD4",
                "course_version": 1,
                "name": "Bias and Its Impact on Health",
                "course_type": 1,
                "author_information": "Dr. Melissa Desroches, Ph.D., RN, CNE",
                "description": "You will begin your exploration of implicit and explicit bias and its impact on health outcomes for adults with Intellectual and Developmental Disabilities. This content will be foundational to the development of your confidence and skills around caring for the population.",
                "learning_objectives_html": "By the time you complete this course, you will be able to:\r\n<ul>\r\n    <li>Describe implicit and explicit attitude formation and common misconceptions and biases</li>\r\n    <li>Identify care outcomes that occur due to these misconceptions</li>\r\n    <li>Explain challenges and ameliorative strategies for caring for hospitalized adults with IDD</li>\r\n    <li>Detail the specific issues with quality-of-life assumptions</li>\r\n    <li>Discuss how to apply the principles of culture competency to include disability and ID</li>\r\n</ul>",
                "course_outline_html": "none provided",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "0C0B7090-D960-F011-99A0-005056A740BF",
                        "course_category_name": "Golisano - Optimizing Care for Hospitalized Individuals with Intellectual and Developmental Disabilities - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B756B56E-BDD2-EB11-80E3-005056B142B5",
                        "course_category_name": "LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B2501C7D-77CF-EF11-9993-005056A7D0C4",
                        "course_category_name": "CNA: Certified Nursing Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FEB7B714-954B-46A4-89D6-628F916FB59B",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B92FC0B9-AF4B-F011-99A4-005056A77B46",
                        "course_category_name": "CE Unlimited_BRIDGE (No DEI Courses)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "162D7419-F1DE-4896-A447-ED5F2D41A1C1",
                        "course_category_name": "CMSRN: Medical-Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2E429D0C-4610-EE11-997D-005056A730AF",
                        "course_category_name": "Golisano",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BDB7B074-BDD2-EB11-80E3-005056B142B5",
                        "course_category_name": "Registered Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "552455CB-0469-E811-B6FF-005056B10E33",
                        "course_category_name": "CE Unlimited featuring Challenge Tracks",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F0D93E9B-C313-F011-999F-005056A77B46",
                        "course_category_name": "Golisano-CEUnlimited",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6592CD9A-C7AC-4DD4-A98A-2D6483554821",
                        "course_category_name": "CRRN: Rehabilitation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2F5C3339-BDD2-EB11-80E3-005056B142B5",
                        "course_category_name": "Advance Practice Registered Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "53A09CBA-47F5-41DE-ABBC-397BDE607DA7",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "<em>The Golisano Institute for Developmental Disability Nursing is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation. Provider Number P0691</em>",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "AB3795BD-550F-EE11-997D-005056A74C71",
                "course_version": 2,
                "name": "Effective Communication: Individuals with Intellectual and Developmental Disabilities (IDD) in the Hospital Setting",
                "course_type": 1,
                "author_information": "Dr. Deborah Napolitano, Ph.D., BCBA-D, LBA",
                "description": "In this module, you will explore the varied approaches to communication people with intellectual and developmental disabilities may utilize and learn skills that foster effective communication with this population in the acute care setting.",
                "learning_objectives_html": "By the time you complete this course, you will be able to:\r\n<ul>\r\n    <li>Describe the variety of ways people with IDD communicate</li>\r\n    <li>Identify the components of communication</li>\r\n    <li>Incorporate&nbsp;best practices to foster effective communication&nbsp;in the acute care setting</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "0C0B7090-D960-F011-99A0-005056A740BF",
                        "course_category_name": "Golisano - Optimizing Care for Hospitalized Individuals with Intellectual and Developmental Disabilities - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BDB7B074-BDD2-EB11-80E3-005056B142B5",
                        "course_category_name": "Registered Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B92FC0B9-AF4B-F011-99A4-005056A77B46",
                        "course_category_name": "CE Unlimited_BRIDGE (No DEI Courses)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FEB7B714-954B-46A4-89D6-628F916FB59B",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "53A09CBA-47F5-41DE-ABBC-397BDE607DA7",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "552455CB-0469-E811-B6FF-005056B10E33",
                        "course_category_name": "CE Unlimited featuring Challenge Tracks",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B756B56E-BDD2-EB11-80E3-005056B142B5",
                        "course_category_name": "LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2F5C3339-BDD2-EB11-80E3-005056B142B5",
                        "course_category_name": "Advance Practice Registered Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F0D93E9B-C313-F011-999F-005056A77B46",
                        "course_category_name": "Golisano-CEUnlimited",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2E429D0C-4610-EE11-997D-005056A730AF",
                        "course_category_name": "Golisano",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "The Golisano Institute for Developmental Disability Nursing is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center's Commission on Accreditation. Provider Number P0691",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            }
        ]
    }
];